import type { BillingIssue } from '@borradh-workspace/contracts';
import { createContext, useContext } from 'react';

export const BillingRecoveryContext = createContext<BillingIssue | null>(null);

/** Plain supporting copy for pages whose data may be unavailable due to billing. */
export function BillingErrorText() {
  const issue = useContext(BillingRecoveryContext);
  if (!issue) return null;
  return (
    <p className="text-sm text-muted-foreground" role="status">
      {issue.title}. {issue.paymentFailureReason ?? issue.message}
    </p>
  );
}
